module.exports = __webpack_public_path__ + "img/thumb_04.1b99ca20.jpg";